export enum CustodianRouteSegment {
  Custodian = 'home',
  TaxFormPrePopulation = 'tax-form-pre-population',
  TaxRiskReporting = 'tax-risk-reporting',
  TaxAuthQueryManagement = 'tax-auth-query-management',
  AddOnTaxServices = 'add-on-tax-services',
  QueryManagement = 'query-mananagement',
  TaxReclaimAccrualChecks = 'tax-reclaim-accrual-checks',
}
